<template>
  <div class="wan-resources-upload-wrap">
    <!-- *选择资源格式 -->
    <div class="file-type-wrap">
      <div class="title-wrap">
        <div class="title">*选择资源格式</div>
        <div v-if="ruleForm.fileType" class="msg">
          {{ fileMsg[ruleForm.fileType].msg }}{{ pcLimit
          }}{{ pcLimit ? "m以内" : "" }}
        </div>
      </div>

      <el-radio-group v-model="ruleForm.fileType" @change="changeFileType">
        <el-radio v-for="item in fileTypeList" :key="item.id" :label="item.id"
        >{{ item.name }}
        </el-radio>
      </el-radio-group>
    </div>

    <!-- *上传文件或添加链接 -->
    <div class="wan-resources-upload-content">
      <div class="file-type-wrap" style="">
        <div class="title-wrap">
          <div class="title">*上传文件或添加链接</div>
        </div>

        <el-radio-group v-model="ruleForm.linkType">
          <el-radio :label="0">上传文件</el-radio>
          <el-radio :label="1">引用链接</el-radio>
        </el-radio-group>
        <div class="file-list" v-if="!ruleForm.linkType">
          <!-- 上传图片的样式  -->
          <div
            v-for="(item, index) in fileList"
            :key="index"
            class="file-item"
            style="margin-bottom: 10px"
          >
            <p v-if="ruleForm.fileType === 120 && fileList.length">
              {{ item.name }}
            </p>
            <p
              v-if="ruleForm.fileType === 120 && fileList.length"
              class="upload-plus"
              @click="fileList.splice(index, 1)"
            >
              [删除]
            </p>
          </div>

          <!-- 上传其他文件的样式  -->
          <div class="file-item">
            <!-- 文件名 -->
            <div>
              <div
                v-for="(item, index) in fileList"
                :key="index"
                style="display: flex; justify-content: space-between"
              >
                <p v-if="ruleForm.fileType !== 120">
                  {{ item.name }}
                </p>
              </div>
            </div>

            <!-- 上传 -->
            <el-upload
              v-if="ruleForm.fileType"
              ref="file-upload"
              :accept="fileMsg[ruleForm.fileType].accept"
              :auto-upload="false"
              :multiple="ruleForm.fileType === 120"
              :on-change="pickFile"
              :show-file-list="false"
              action=""
              list-type="picture-card"
            >
              <p class="upload-plus">[选择文件]</p>
            </el-upload>
          </div>
        </div>
        <div class="file-list link-dev" v-else>
          <el-input
            v-model="ruleForm.fileUrl"
            placeholder="请输入链接地址"
            show-word-limit
            type="text"
          >
          </el-input>
          <p class="upload-plus" @click="pasteLink">[粘贴地址]</p>
        </div>
      </div>
    </div>

    <!-- 横竖版式 -->
    <div v-if="[85, 122].includes(ruleForm.fileType)" class="wan-resources-upload-content">
      <div class="title-wrap">
        <div class="title">横竖版式</div>
        <div class="msg">设置仅针对万众空间小程序有效</div>
      </div>

      <el-radio-group v-model="ruleForm.screenModel">
        <el-radio :label="0">竖屏</el-radio>
        <el-radio :label="1">横屏</el-radio>
      </el-radio-group>
    </div>

    <!-- 是否全屏 -->
    <div v-if="ruleForm.fileType === 122" class="wan-resources-upload-content">
      <div class="title-wrap">
        <div class="title">是否全屏</div>
        <div class="msg">设置仅针对万众空间小程序有效</div>
      </div>

      <el-radio-group v-model="ruleForm.fullScreen">
        <el-radio :label="0">否</el-radio>
        <el-radio :label="1">是</el-radio>
      </el-radio-group>
    </div>

    <!-- **选择档务分类 -->
    <div class="wan-resources-upload-content">
      <div class="title-wrap">
        <div class="title">*选择档务分类</div>
        <div class="msg">分类支持多选</div>
        <div class="operation" @click="pickClassify">
          [{{ drawerParams.drawerType === 1 ? "设置分类" : "修改分类" }}]
        </div>
      </div>

      <!-- 选择分类 -->
      <div v-if="classifyType" class="classify-add-wrap">
        <!-- 系统分类 -->
        <div v-for="item in sysClassList" :key="item.id" class="classify-item">
          <div class="title">{{ item.name }}</div>
          <div class="classify-item-checkbox">
            <el-checkbox-group v-model="item.subList">
              <el-checkbox
                v-for="item2 in item.subclassList"
                :key="item2.id"
                :label="item2.id"
              >{{ item2.name }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <!-- 自定义分类 -->
        <div
          v-for="item in customClassList"
          :key="item.id"
          class="classify-item"
        >
          <div class="title">{{ item.name }}</div>
          <div class="classify-item-checkbox">
            <el-checkbox-group v-model="item.subList">
              <el-checkbox
                v-for="item2 in item.subclassList"
                :key="item2.id"
                :label="item2.id"
              >{{ item2.name }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>

      <!-- 确定分类 -->
      <div v-else class="classify-look-wrap">
        <!-- 选中后的系统分类 -->
        <div
          v-for="item in checkedSysList"
          :key="item.id"
          class="classify-item"
        >
          <div class="title">{{ item.name }}：</div>
          <div
            v-for="(item2, index2) in item.subList"
            :key="item2.id"
            class="classify-item-checkbox"
          >
            {{ item2.name }}{{ index2 === item.subList.length - 1 ? "" : "，" }}
          </div>
        </div>
        <!-- 选中后的自定义分类 -->
        <div
          v-for="item in checkedCustomList"
          :key="item.id"
          class="classify-item"
        >
          <div class="title">{{ item.name }}：</div>
          <div
            v-for="(item2, index2) in item.subList"
            :key="item2.id"
            class="classify-item-checkbox"
          >
            {{ item2.name }}{{ index2 === item.subList.length - 1 ? "" : "，" }}
          </div>
        </div>
      </div>
    </div>

    <!-- 资源名称 -->
    <div class="wan-resources-upload-content">
      <div class="title-wrap">
        <div class="title">*资源名称</div>
        <div class="msg">限24字以内</div>
      </div>

      <el-input
        v-model="ruleForm.resName"
        maxlength="24"
        placeholder="请输入资源名称"
        show-word-limit
        type="text"
      >
      </el-input>
    </div>

    <!-- 关键词 -->
    <div class="wan-resources-upload-content">
      <div class="title-wrap">
        <div class="title">关键词</div>
        <div class="msg">便于检索资源，词之间用空隔间隔</div>
      </div>

      <el-input
        v-model="ruleForm.keyword"
        placeholder="请输入关键词"
        show-word-limit
      >
      </el-input>
    </div>

    <!-- 资源介绍 -->
    <div class="wan-resources-upload-content">
      <div class="title-wrap">
        <div class="title">资源介绍</div>
        <div class="msg">限240字以内</div>
      </div>

      <el-input
        v-model="ruleForm.remark"
        :rows="6"
        maxlength="240"
        placeholder="请输入资源介绍"
        show-word-limit
        type="textarea"
      >
      </el-input>
    </div>

    <!-- 关联合作 -->
    <!--    <div class="wan-resources-upload-content">
          <div class="title-wrap">
            <div class="title">关联合作</div>
          </div>

          <el-select
            v-model="ruleForm.resAscr"
            placeholder="请选择关联合作"
            style="width: 100%"
          >
            <el-option
              v-for="item in customerList"
              :key="item.id"
              :label="item.cusName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>-->

    <!-- 小程序分享图 -->
    <div class="wan-resources-upload-content">
      <div class="title-wrap">
        <div class="title">小程序分享图</div>
        <div class="msg">
          通过小程序对外转发该资源时使用，建议图片比例为500PX：400PX
        </div>
      </div>

      <!-- 小程序分享图 上传组件-->
      <div class="upload-img-wrap">
        <el-upload
          ref="wx-upload"
          accept="image/*,video/*"
          :auto-upload="false"
          :on-change="changeWXImg"
          :show-file-list="false"
          action=""
          list-type="picture-card"
        >
          <img
            v-if="ruleForm.coverUrl"
            :src="ruleForm.coverUrl"
            alt=""
            class="avatar"
          />
          <div v-else class="upload-plus">上传</div>
        </el-upload>

        <!-- 从空间图库中快速选择 -->
        <div class="space-img-list-wrap">
          <div class="title-wrap">
            <div class="right">
              <div class="title">空间图库快速选择</div>
              <i class="el-icon-arrow-left" @click="changeScrollImg('l')"></i>
              <i class="el-icon-arrow-right" @click="changeScrollImg('r')"></i>
            </div>
          </div>
          <div ref="space-imgs-list" class="space-imgs-list">
            <img
              v-for="item in spaceImagesList"
              :key="item.id"
              :src="item.imageUrl"
              alt=""
              style="width: 150px; height: 120px"
              @click="pickSpaceImg(item)"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 空间展示图 -->
    <div class="wan-resources-upload-content">
      <div class="title-wrap">
        <div class="title">空间展示图</div>
        <div class="msg">小程序中，不同的展示效果需要不同尺寸的效果图</div>
      </div>

      <!-- 空间展示图 上传组件-->
      <div class="upload-space-img-wrap">
        <el-upload
          ref="space-upload"
          accept="image/*"
          :auto-upload="false"
          :on-change="changeSpcaeImg"
          :show-file-list="false"
          :style="{
            width: 384 + 'px',
            height: displayH + 'px',
          }"
          action=""
          list-type="picture-card"
        >
          <img
            v-if="
              showImageList &&
              showImageList.length &&
              showImageList[imgSizeIndex].showUrl
            "
            :src="showImageList[imgSizeIndex].showUrl"
            alt=""
            class="avatar"
          />
          <div v-else class="upload-plus">
            建议图片比例{{ imgSizeW }}：{{ imgSizeH }} 上传
          </div>
        </el-upload>

        <div class="msg">
          <p
            v-for="(item, index) in showImageList"
            :key="index"
            :class="imgSizeIndex === index ? 'active' : ''"
            @click="changeImgSize(item.w, item.h, index)"
          >
            {{ item.name }}
          </p>
          <!-- <p
            :class="imgSizeIndex === 1 ? 'active' : ''"
            @click="changeImgSize(1280, 720, 1)"
          >
            [单横图/二列图 1280PX*720PX]
          </p>
          <p
            :class="imgSizeIndex === 2 ? 'active' : ''"
            @click="changeImgSize(360, 700, 2)"
          >
            [竖屏滑 360PX*700PX]
          </p>
          <p
            :class="imgSizeIndex === 3 ? 'active' : ''"
            @click="changeImgSize(750, 422, 3)"
          >
            [详情图 750PX*422PX]
          </p>-->
        </div>
      </div>
    </div>

    <wan-cropper
      ref="wan-cropper"
      :cropper-params="cropperParams"
      @onsubmit="onsubmitCropper"
    ></wan-cropper>
  </div>
</template>

<script>
const defaultForm = {
  resName: "",
  resAscr: "",
  remark: "",
  keyword: "",
  fileType: null,
  fileUrl: '',
  resClass: "",
  customContentCate: "",
  freeCoverUrl: "",
  coverUrl: "",
  screenModel: 0,
  fullScreen: 0,
  linkType: 1,
  showImageList: []
}
import wanCropper from "@/components/wan-cropper";
import { mapState } from "vuex";

export default {
  name: "wan-resources-upload",

  components: {
    wanCropper
  },

  props: {
    // 分类数据
    classifyList: {
      type: Array,
      default: () => [{}, {}, {}]
    },

    // 弹窗参数
    drawerParams: {
      type: Object,
      default: () => ({})
    },

    // 编辑数据
    drawerDetails: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    ...mapState(["userInfo"])
  },

  watch: {
    drawerDetails: {
      handler(n) {
        // form表单赋值
        this.ruleForm = JSON.parse(
          JSON.stringify({
            ...n,
            showImageList: n.showImageList ? n.showImageList : []
          })
        );
        if (this.ruleForm.showImageList.length > 0) {
          this.showImageList.forEach((item, index) => {
            item.showId = this.ruleForm.showImageList[index].showId;
            item.showUrl = this.ruleForm.showImageList[index].showUrl;
            item.showType = this.ruleForm.showImageList[index].showType;
          });
        }
        // 删除列表上一些没用的字段
        delete this.ruleForm.qrCode;
        delete this.ruleForm.id;
        // 文件列表赋值
        this.fileList = this.ruleForm.resName
          ? [{ name: this.ruleForm.resName, url: this.ruleForm.fileUrl }]
          : [];
        // 分类选择按钮赋值
        this.classifyType = this.drawerParams.drawerType === 1;
        // 系统分类赋值
        this.checkedSysList = this.ruleForm.resClass
          ? JSON.parse(this.ruleForm.resClass)
          : [];
        // 内容分类赋值
        this.checkedCustomList = this.ruleForm.customContentCate
          ? JSON.parse(this.ruleForm.customContentCate)
          : [];
      },
      deep: true,
      immediate: true
    }
  },

  data() {
    return {
      // 表单数据
      ruleForm: {...defaultForm},

      showImageList: [
        {
          name: "[图标式 200PX*200PX]",
          w: 200,
          h: 200,
          showUrl: "",
          showUrlRaw: "",
          showType: 0,
          showId: null
        },
        {
          name: "[单横图/二列图 1280PX*720PX]",
          w: 1280,
          h: 720,
          showUrl: "",
          showUrlRaw: "",
          showType: 1,
          showId: null
        },
        {
          name: "[竖屏滑 360PX*700PX]",
          w: 360,
          h: 700,
          showUrl: "",
          showUrlRaw: "",
          showType: 3,
          showId: null
        },
        {
          name: "[详情图 750PX*422PX]",
          w: 750,
          h: 422,
          showUrl: "",
          showUrlRaw: "",
          showType: 4,
          showId: null
        }
      ],

      fileMsg: {
        85: {
          accept: ".mp4",
          msg: "视频：格式mp4，编码H264，音频AAC，文件大小："
        },
        119: {
          accept: ".mp3",
          msg: "音频：请上传格式为mp3的声音文件，文件大小："
        },
        120: {
          accept: "image/*",
          msg: "图片：支持上传多个JPG，PNG格式图片，每张文件大小："
        },
        129: {
          accept: ".ppt,.pptx,.doc,.docx,.pdf,.xls,.xlsx,.txt",
          msg: "文档：支持ppt、word、xls、pdf四种类型，文件大小："
        },
        122: {
          accept: ".zip",
          msg: "H5：格式zip，确保包根目录存在index.html，文件大小："
        },
        130: {
          accept: ".zip,.rar",
          msg: "其它：仅支持zip包作为文件备份之用，文件大小："
        }
      },
      pcLimit: "",

      // 文件类型
      fileTypeList: [],
      // 文件列表
      fileList: [],

      // 图片剪裁的参数
      cropperParams: {},
      imgType: "",

      // 系统内容分类
      sysClassList: [],
      customClassList: [],
      // 选中的分类数据
      checkedSysList: [],
      checkedCustomList: [],
      classifyType: false,

      // 关联合作
      customerList: [],

      // 空间图库
      spaceImagesList: [],

      // 单横图... 图片尺寸所在index
      imgSizeIndex: 0,
      imgSizeW: 200,
      imgSizeH: 200,
      displayH: 384,
      file: {}
    };
  },

  async created() {
    this.$bus.on("submitScreenshot", (url) => {
      this.changeImg({ ...this.file, url }, [], "coverUrl");
    });

    // 获取文件类型
    this.fileTypeList = await this.$utils.getClassSetList();
    // 获取关联合作
    this.customerList = await this.$utils.getCustomerList();
    // 获取分类
    this.sysClassList = await this.$utils.getSysContentCateList();
    this.customClassList = await this.$utils.getCustomContentCateList();

    // 获取空间图库
    this.getGalleryList();
    // 获取资源编号
    this.getResoureNo();
    // 默认选中编辑的文件类型
    this.changeFileType(Number(this.ruleForm.fileType));

    this.$bus.emit("closeH5");
  },

  methods: {
    // 获取资源编号
    getResoureNo() {
      // 新增时获取
      if (this.drawerParams.drawerType === 1) {
        this.ruleForm = {
          ...defaultForm
        };
        this.$http.getResoureNo().then(({ data }) => {
          this.$set(this.ruleForm, "resoureNo", data.resoureNo);
        });
      }
    },

    // 选择文件类型
    changeFileType(v) {
      console.log(v, "vvv");
      if (!v) return;
      this.pcLimit = this.fileTypeList.filter(
        (item) => item.id === v
      )[0].pcLimit;
      // 切换文件类型清空选择的文件
      // this.fileList = [];
    },

    // 选择文件
    pickFile(file) {
      console.log(this.fileList);
      // console.log(file.size, Number(this.pcLimit));
      if (file.size / 1024 / 1024 > Number(this.pcLimit)) {
        return this.$message.warning("文件大小超出最大限制！");
      }
      if (this.ruleForm.fileType === 120) {
        // 图片可以添加多个
        this.fileList.push(file);
      } else {
        this.fileList = [file];
      }
      // 如果没有填资源名称 默认使用文件名称
      if (!this.ruleForm.resName) {
        const str = file.name;
        // 通过分隔字符串，成字符串数组
        const arr = str.split(".");
        // 取最后一个，就是文件名
        const last = arr[arr.length - 1];
        const fileName = str.substr(0, str.length - last.length - 1);
        this.$set(this.ruleForm, "resName", fileName.slice(0, 24));
      }

      if (this.ruleForm.fileType === 85) {
        this.changeWXImg(file, this.fileList, "coverUrl");
      }
      // this.$utils.uploadFiles(file.raw);
    },

    // 确定分类or选择分类
    pickClassify() {
      if (this.classifyType) {
        // 确定分类
        let list = [],
          list2 = [];
        // 获取选中的系统分类
        this.sysClassList.forEach((item) => {
          if (item.subList && item.subList.length) {
            let subList = [];
            item.subclassList.forEach((item2) => {
              if (item.subList.indexOf(item2.id) > -1) {
                subList.push({
                  id: item2.id,
                  name: item2.name
                });
              }
            });
            list.push({
              id: item.id,
              name: item.name,
              subList: subList
            });
          }
        });
        // 获取选中的自定义分类
        this.customClassList.forEach((item) => {
          if (item.subList && item.subList.length) {
            let subList = [];
            item.subclassList.forEach((item2) => {
              if (item.subList.indexOf(item2.id) > -1) {
                subList.push({
                  id: item2.id,
                  name: item2.name
                });
              }
            });
            list2.push({
              id: item.id,
              name: item.name,
              subList: subList
            });
          }
        });

        this.checkedSysList = list;
        this.checkedCustomList = list2;
        this.ruleForm.resClass =
          list && list.length ? JSON.stringify(list) : "";
        this.ruleForm.customContentCate =
          list2 && list2.length ? JSON.stringify(list2) : "";
        console.log(list, list2);
      } else {
        // 获取选中的系统分类
        this.sysClassList = this.sysClassList.map((item) => {
          let a = this.checkedSysList.filter((v) => v.id === item.id);
          return {
            ...item,
            subList:
              a.length > 0 && a[0].subList && a[0].subList.length > 0
                ? a[0].subList.map((v) => v.id)
                : []
          };
        });
        // 获取选中的自定义分类
        this.customClassList = this.customClassList.map((item) => {
          let a = this.checkedCustomList.filter((v) => v.id === item.id);
          return {
            ...item,
            subList:
              a.length > 0 && a[0].subList && a[0].subList.length > 0
                ? a[0].subList.map((v) => v.id)
                : []
          };
        });
      }

      this.classifyType = !this.classifyType;
    },

    async pasteLink() {
      const val = await navigator.clipboard.readText();
      console.log(val, 'val');
      this.ruleForm.fileUrl = val
    },

    // 空间图库
    getGalleryList() {
      this.$http
        .getGalleryList({
          pageIndex: 1,
          pageSize: 10,
          condition: { spaceId: this.userInfo.id }
        })
        .then(({ data }) => {
          this.spaceImagesList = data.result;
        });
    },

    // 选择空间图库
    pickSpaceImg(item) {
      this.$set(this.ruleForm, "coverUrl", item.imageUrl);
    },

    // change 小程序滚动图
    async changeWXImg(file, fileList) {
      this.file = file;
      console.log(file.raw.type, "文件类型");
      if (file.raw.type.indexOf("video") > -1) {
        this.$bus.emit("openH5", {
          url: file.url,
          title: "拖动视频进度确定截图位置",
          fileType: 85,
          isScreenshot: true
        });
        return;
        // file.url = await this.$utils.findVideoCover(file.url);
      }
      this.changeImg(file, fileList, "coverUrl");
    },

    // change空间滚动图
    changeSpcaeImg(file, fileList) {
      this.changeImg(file, fileList, "freeCoverUrl");
    },

    // 选择图片打开剪裁
    changeImg(file, fileList, type) {
      console.log(file, fileList, type);
      // 图片赋值
      // this.$set(this.cropperParams, "img", file.url);
      this.imgType = type;
      let fixedNumber = [];
      if (type === "coverUrl") {
        fixedNumber = [500, 400];
      } else {
        console.log(this.imgSizeW, this.imgSizeH);
        fixedNumber = [this.imgSizeW, this.imgSizeH];
      }
      this.cropperParams = { ...file, fixedNumber };
      this.$refs["wan-cropper"].cropperVisible = true;
    },

    // 剪裁保存
    onsubmitCropper({ file, imageUrl }) {
      console.log(file, imageUrl);
      // this.ruleForm[this.imgType] = imageUrl;
      // 空间分享图
      if (this.imgType === "freeCoverUrl") {
        this.showImageList[this.imgSizeIndex].showUrl = imageUrl;
        this.showImageList[this.imgSizeIndex].showUrlRaw = file;
      } else {
        this.$set(this.ruleForm, this.imgType, imageUrl);
        this.$set(this.ruleForm, this.imgType + "Raw", file);
      }
    },

    // 滚动小程序图库的图
    changeScrollImg(v) {
      const n = 155;
      this.$refs["space-imgs-list"].scrollLeft =
        this.$refs["space-imgs-list"].scrollLeft + (v === "r" ? +n : -n);
    },

    // 选择不同尺寸类型
    changeImgSize(w, h, index) {
      this.imgSizeW = w;
      this.imgSizeH = h;
      this.imgSizeIndex = index;

      switch (index) {
        case 0:
          this.displayH = 384;
          break;
        case 1:
          this.displayH = 216;
          break;
        case 2:
          this.displayH = 747;
          break;
        case 3:
          this.displayH = 216;
          break;
      }
    }
  }
};
</script>

<style scoped></style>
